import type { FulfillmentMethod } from '../product-details';

export enum MiniPdpSource {
    YMAL = 'ymal',
}

export type MiniPdpDrawerOptions = {
    productId?: string;
    source?: MiniPdpSource;
};

export type MiniPdpDrawerState = {
    isOpen: boolean;
    productId: string | null;
    source?: MiniPdpSource;
    open: (options?: MiniPdpDrawerOptions) => void;
    close: () => void;
};

export type MiniPdpDrawerProps = Readonly<{
    className?: string;
}>;

export type MiniPdpForm = {
    selectedSku: string;
    fulfilmentMethod: FulfillmentMethod;
    quantity: number;
};
